import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { StreamingNotification } from "./StreamingNotification";
import { i18n } from "./StreamingTimeExceededNotification.i18n";
const StreamingTimeExceededNotification = React.memo((props) => {
    return _jsx(StreamingNotification, { ...props, i18n: i18n });
});
export { StreamingTimeExceededNotification };
//# sourceMappingURL=StreamingTimeExceededNotification.js.map